import { render } from "./SportsEquipment.vue?vue&type=template&id=a3fb0bfe&scoped=true"
import script from "./SportsEquipment.vue?vue&type=script&lang=js"
export * from "./SportsEquipment.vue?vue&type=script&lang=js"

import "./SportsEquipment.vue?vue&type=style&index=0&id=a3fb0bfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3fb0bfe"]])

export default __exports__